import React from 'react';
import loading from '@assets/icons/loading-icon.png';
import Icon from '@components/Input/components/Icon';

const LoadingIcon = () => (
  <Icon showLoading>
    <img src={loading} />
  </Icon>
);

export default LoadingIcon;
